import React, { ReactElement } from "react";

import { Container, Row, Col, Card, Ratio } from "react-bootstrap";
import { Timeline } from "react-twitter-widgets";
import UpcomingDataTable from "./shared/UpcomingDataTable";
import Footer from "./Footer";
import { SettingsContext } from "../hooks/settings-context";

export default function Iss(): ReactElement {
  return (
    <SettingsContext.Consumer>
      {({ apiEndpoint }) => (
        <div className="iss-container" style={{ color: "white" }}>
          <Container fluid>
            <Row className="custom__row full-height">
              <Col md={6} className="full-height">
                <Row className="full-height iss-left-row">
                  <Col md={6} className="full-height">
                    <Card className="pb-1 pt-1 px-1 full-height">
                      <h6 className="iss-panel-header">Twitter Feed</h6>
                      <div className="iss-card-content">
                        <Timeline
                          dataSource={{
                            sourceType: "profile",
                            screenName: "Space_Station",
                          }}
                          options={{
                            chrome: "noheader, nofooter",
                            height: "calc(100vh - 177px)",
                          }}
                        />
                      </div>
                    </Card>
                  </Col>
                  <Col md={6} className="full-height">
                    <Card className="pb-1 pt-1 px-1 full-height">
                      <h6 className="iss-panel-header">Earth From ISS</h6>
                      <div className="iss-card-content iss-earth-content full-height">
                        <Ratio aspectRatio="16x9" className="iss-earth-ratio">
                          <iframe
                            title="ISS stream 1"
                            src="https://ustream.tv/embed/17074538?html5ui=1&autoplay=true"
                            width="100%"
                          />
                        </Ratio>
                        <Ratio aspectRatio="16x9" className="iss-earth-ratio mt-2">
                          <iframe
                            title="ISS stream 2"
                            src="https://ustream.tv/embed/9408562?html5ui=1&autoplay=true"
                            height="100%"
                          />
                        </Ratio>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Col>
              <Col md={6} className="full-height">
                <div className="iss-col full-height">
                  <Card className="pb-1 pt-1 px-1 full-height">
                    <h6 className="iss-panel-header" style={{ display: "flex", justifyContent: "space-between" }}>
                      ISS Tracker
                      <a href="/" className="custom-btn__circular minus" aria-label="Close">
                        {" "}
                      </a>
                    </h6>
                    <div className="iss-card-content">
                      <iframe
                        title="iss-tracker"
                        src="https://isstracker.pl/en/widget/map?&disableInfoBox=1&lang=en&z=2&mapType=satellite&units=metric&preloader=0&showSatTooltip=0&dayNightLayer=1&showFutureOrbit=1"
                        className="full-height"
                      />
                    </div>
                  </Card>
                  <Card className="pb-1 pt-1 px-1 full-height">
                    <h6 className="iss-panel-header">Upcoming Passes</h6>
                    <div className="iss-card-content">
                      <UpcomingDataTable
                        apiEndpoint={apiEndpoint}
                        maxHeight="100%"
                      />
                    </div>
                  </Card>
                </div>
              </Col>
            </Row>
          </Container>
          <Footer />
        </div>
      )}
    </SettingsContext.Consumer>
  );
}
